export const LocalStorageIdentifier = {
  QUERY_PARAMETER_DEFAULTS: 'nw-query-parameter-defaults',
  COLOR_SCHEME: 'nw-color-scheme',
  SETTINGS: 'nw-console-settings',
  SIDEBAR_WORKSPACE_EXPANDED: 'nw-sidebar-workspace-expand-state',
  SIDEBAR_ORGANIZATION_EXPANDED: 'nw-sidebar-organization-expand-state',
  RECENTLY_USED_ENVIRONMENT: 'nw-recently-used-environment',
} as const

export const SessionStorageIdentifier = {
  SESSION_CONFIGURATION: 'nw-session-configuration',
} as const
